"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDisconnect = void 0;
const constants_1 = require("../utils/constants");
function useDisconnect() {
    const disconnect = () => {
        if (window.parent) {
            const message = JSON.stringify({
                type: constants_1.eventTypes.disconnect,
                success: true,
            });
            window.parent.postMessage(message, document.referrer);
        }
        window.localStorage.removeItem(constants_1.TRIA_WALLET_STORE);
    };
    return { disconnect };
}
exports.useDisconnect = useDisconnect;
